import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home-8-line",
  "use": "icon-home-8-line-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-home-8-line\">\n    <g>\n        <path fill=\"none\" d=\"M0 0h24v24H0z\" />\n        <path d=\"M19 21H5a1 1 0 0 1-1-1v-9H1l10.327-9.388a1 1 0 0 1 1.346 0L23 11h-3v9a1 1 0 0 1-1 1zM6 19h12V9.157l-6-5.454-6 5.454V19zm3-9h6v6H9v-6zm2 2v2h2v-2h-2z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol